import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, FormControl } from '@angular/forms';

@Directive({
  selector: '[payMaxValue][formControlName],[payMaxValue][formControl],[payMaxValue][ngModel]',
  providers: [{ provide: NG_VALIDATORS, useExisting: MaxValueDirective, multi: true }]
})
export class MaxValueDirective implements Validator {
  @Input()
  payMaxValue: number;

  validate(c: FormControl): { [key: string]: any } {
    let v = c.value;
    if (this.payMaxValue)
      return (v > this.payMaxValue) ? { "payMaxValue": true } : null;
  }
} 


// WEBPACK FOOTER //
// ./src/directives/max-validator.directive.ts